export default __webpack_public_path__ + "static/media/matkareel.a369f5d7.mp3";